/**
 * Performant logging utility for OfferChat.ai
 * Only logs in development mode to improve production performance
 */

const isDevelopment = process.env.NODE_ENV === 'development';

export const performantLogger = {
  debug: (...args: unknown[]) => {
    if (isDevelopment) {
      console.debug(...args);
    }
  },
  
  info: (...args: unknown[]) => {
    if (isDevelopment) {
      console.info(...args);
    }
  },
  
  warn: (...args: unknown[]) => {
    console.warn(...args); // Always show warnings
  },
  
  error: (...args: unknown[]) => {
    console.error(...args); // Always show errors
  },
  
  // Structured logging for chat events
  chat: (component: string, event: string, data?: unknown) => {
    if (isDevelopment) {
      console.debug(`[CHAT] [${component}] ${event}`, data);
    }
  },
  
  // Performance logging
  performance: (metric: string, value: number, unit = 'ms') => {
    if (isDevelopment) {
      console.debug(`[PERF] ${metric}: ${value}${unit}`);
    }
  }
};
